<template>
    <div class="product-slider" v-if="result">
        <!--Thumbs slider-->
        <div>
            <swiper
                v-if="screenWidth >= 768"
                :modules="[Thumbs]"
                @swiper="setThumbsSwiper"
                v-bind="verticalSettings"
                class="product-vertical"
            >
                <swiper-slide
                    v-for="(item, i) in result"
                    :key="i"
                >
                    <img
                        :src="item.preview"
                        :alt="item.alt"
                        class="product-vertical__image"
                    >
                </swiper-slide>
            </swiper>
        </div>
        <DefSliderWrapper>
            <!-- Main slider -->
            <swiper
                :thumbs="{ swiper: thumbsSwiper }"
                :modules="mainSliderModules"
                v-bind="horizontalSettings"
                class="product-horizontal"
            >
                <swiper-slide
                    v-for="(item, i) in result"
                    :key="i"
                >
                    <DefZoom
                        v-if="screenWidth >= 992"
                        :src="item.src"
                        :alt="item.alt"
                    />
                    <img
                        v-else
                        :src="item.src"
                        :alt="item.alt"
                        class="product-horizontal__image"
                    >
                </swiper-slide>
            </swiper>
        </DefSliderWrapper>
    </div>
</template>

<script setup>
import { defineProps, ref } from 'vue';
import {Swiper, SwiperSlide} from 'swiper/vue';
import { Thumbs } from 'swiper';
import { Pagination } from 'swiper';
import DefSliderWrapper from "./DefSliderWrapper";

const mainSliderModules = [Pagination, Thumbs];

const { result } = defineProps(['result']);
const horizontalSettings = {
    slidesPerView: 1,
    breakpoints: {
        768: {
            pagination: {
                enabled: false,
            },
        }
    }
}

if (result?.length > 1) {
    horizontalSettings.pagination = { clickable: true };
}
const verticalSettings = {
    direction: 'vertical',
    autoHeight: true,
    watchSlidesProgress: true,
    spaceBetween: 8,
    breakpoints: {
        992: {
            slidesPerView: 5
        },
        768: {
            slidesPerView: 7
        },
        576: {
            slidesPerView: 3
        },
        300: {
            slidesPerView: 2
        },
    }
};

const slide = ref(0);

const thumbsSwiper = ref(null);
const setThumbsSwiper = (swiper) => {
    thumbsSwiper.value = swiper;
};
</script>

<script>
export default {
    name: 'ProductSlider',
}
</script>
<style lang="scss" scoped>
.product-slider {
    display: grid;
    grid-template-columns: minmax(290px, 1fr);
    @include point-md{
        display: grid;
        grid-template-columns: 32px minmax(0, 1fr);
        grid-column-gap: 8px;
    }
    @include point-lg{
        grid-template-columns: 72px minmax(0, 1fr);
    }
}
.product-vertical{
    //max-height: 632px;
    padding-top: 1px;
    @media (min-width: 576px) {
        height: 112px;
    }
    @include point-md{
        height: 272px;
    }
    @include point-lg{
        height: 392px;
    }
    &__image{
        //max-height: 100%;
        @include point-md{
            max-height: 32px;
        }
        @include point-lg{
            max-height: 72px;
        }
        //max-width: 100%;
        border: 1px solid transparent;
        transition: .2s linear border-color;
    }
    :deep(.swiper-slide-thumb-active){
        .product-vertical__image{
            border-color: #618EAF;
        }
    }
    :deep(.swiper){
        height: 100%;
    }
    :deep(.swiper-slide){
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
}
.product-horizontal{
    &__image{
        max-width: 100%;
    }
    :deep(.def-slider-wrapper .swiper-pagination) {
        margin-top: 16px;
    }
    :deep{
        .zoom{
            display: block;
        }
        .swiper-slide{
            padding: 20px;
            @include point-lg{
                padding: 40px;
            }
        }
        .swiper-pagination{
            margin-top: 16px;
            @include point-lg{
                margin-top: 24px;
            }
        }
    }
}
</style>